import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=95dd654e&scoped=true&"
import script from "./searchForm.vue?vue&type=script&lang=js&"
export * from "./searchForm.vue?vue&type=script&lang=js&"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=95dd654e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dd654e",
  null
  
)

export default component.exports